import ItemImgCard from '@components/dataDisplay/Store/ItemImgCard';
import ModalWrapper from '@components/wrapper/Modal/ModalWrapper';
import React from 'react';
import styled from 'styled-components';
import WalletPrice from '@pages/Store/component/WalletPrice';
import CloseBtn from '@components/dataEntry/button/CloseBtn/CloseBtn';

const Align = styled.div`
  display: flex;
  padding: 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

type Props = {
  closeModal: () => void;
  data: any;
  title?: string;
  contents?: string;
};
function ParchaseConfirmModal({ closeModal, data, title, contents }: Props) {
  // 랜덤박스 아이템인지 확인
  const isRandomBox = data?.functionType === 'random_box';

  return (
    <ModalWrapper
      outsideClick={closeModal}
      contentStyle={{ minWidth: '500px' }}
    >
      <CloseBtn fixed onClick={closeModal} size="md" />

      <Align>
        <ItemImgCard data={data} />

        <h6>{title || (isRandomBox ? '랜덤박스 획득!' : '지급 완료!')}</h6>
        <p>
          {contents ||
            (isRandomBox
              ? '인벤토리에서 사용하여 랜덤 아이템을 오픈하세요!'
              : '캐릭터의 인벤토리 창에서 확인 가능합니다.')}
        </p>

        <WalletPrice showMyWalet />
      </Align>
    </ModalWrapper>
  );
}

export default ParchaseConfirmModal;
